import { Component } from "./Component";
import { settings } from "../const/Settings";
import { DataUtils } from "../libs/utils/DataUtils";
export class CookieBar extends Component {
    init() {
        const cookieAcceptName = settings.globalPrefix + 'accept';
        if (!DataUtils.getCookie(cookieAcceptName) && document.location.href.indexOf('/cookiebeleid') === -1) {
            this.html.classList.add('visible');
            const btnAccept = this.getHtml('accept');
            btnAccept.addEventListener('click', () => {
                this.html.classList.remove('visible');
                DataUtils.setCookie(cookieAcceptName, '1');
            });
        }
        else {
            this.html.style.display = 'none';
        }
    }
}
